module.exports = __webpack_public_path__ + "static/img/share-demo.1a4dab88.png";